// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC<{ width?: number; height?: number }> = ({ width = 24, height = 22 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 22">
            <path
                fill="currentColor"
                d="M0 1c0-.542.467-1 1.02-1h1.912c1.147 0 2.167.792 2.337 1.917L5.312 2h16.997c1.062 0 1.87.958 1.657 2L22.86 9.708c-.34 1.709-1.912 2.959-3.697 2.959H7.266l.255 1.166c.085.5.51.834.978.834h10.878c.552 0 1.02.458 1.02 1 0 .541-.468 1-1.02 1H8.499a3.076 3.076 0 0 1-3.017-2.459L3.272 2.292c0-.167-.17-.292-.34-.292H1.02C.467 2 0 1.542 0 1m6.926 9.667h12.238c.808 0 1.53-.584 1.7-1.334L21.884 4H5.694zM8.838 18c1.148 0 2.04.875 2.04 2s-.892 2-2.04 2c-1.147 0-2.04-.875-2.04-2s.893-2 2.04-2m9.519 0c1.147 0 2.04.875 2.04 2s-.893 2-2.04 2-2.04-.875-2.04-2 .893-2 2.04-2"
            />
        </svg>
    );
};

export default React.memo(Cart);
